import React, { useState } from 'react';
import { Editor } from '@toast-ui/react-editor';

import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';

export const MarkdownEditor = ({ value }) => {
    const [editorValue, setEditorValue] = useState(value);

    return (
        <div className='description-input'>
            <input type='hidden' name='editor' value={editorValue} />
            <Editor
                onKeydown={(value, evt) => {
                    setEditorValue(evt?.target?.innerText);
                }}
                initialValue={editorValue}
                previewStyle="tab"
                height="auto"
                initialEditType="markdown"
                useCommandShortcut={true}
            />
        </div>
    );
};
